import { render } from "./Appendix.vue?vue&type=template&id=4a8d93a1&scoped=true"
import script from "./Appendix.vue?vue&type=script&lang=js"
export * from "./Appendix.vue?vue&type=script&lang=js"

import "./Appendix.vue?vue&type=style&index=0&id=4a8d93a1&lang=less&scoped=true"

import exportComponent from "C:\\projects\\epd-cnmp-web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a8d93a1"]])

export default __exports__